const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeCirclePeatlandRestoration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6954 17.8218C23.9571 17.8218 24.1693 18.0404 24.1693 18.3101V22.7045C24.1693 23.5135 23.5328 24.1693 22.7476 24.1693H9.47811C8.69292 24.1693 8.0564 23.5135 8.0564 22.7045V18.3101C8.0564 18.0741 8.2202 17.8719 8.44553 17.8297L11.052 17.3414C11.08 17.3361 11.1084 17.3335 11.1368 17.3335H13.2694C13.3006 17.3335 13.3318 17.3367 13.3624 17.343L15.6545 17.8153L19.1307 17.3378C19.1797 17.3311 19.2294 17.3323 19.2781 17.3414L21.8425 17.8218H23.6954ZM9.00423 18.7175V22.7045C9.00423 22.9741 9.2164 23.1928 9.47814 23.1928H22.7476C23.0093 23.1928 23.2215 22.9741 23.2215 22.7045V18.7983H21.7998C21.7714 18.7983 21.743 18.7957 21.715 18.7904L19.1819 18.3159L15.7016 18.794C15.6499 18.8011 15.5973 18.7994 15.546 18.7888L13.2225 18.3101H11.1795L9.00423 18.7175ZM16.1128 16.357C14.8042 16.357 13.7433 15.2639 13.7433 13.9156C13.7433 12.8781 14.4277 11.6441 15.7662 10.1648C15.9536 9.95771 16.2721 9.95771 16.4595 10.1648C17.798 11.6442 18.4824 12.8781 18.4824 13.9156C18.4824 15.2639 17.4215 16.357 16.1128 16.357ZM14.6911 13.9156C14.6911 14.7246 15.3277 15.3804 16.1128 15.3804C16.898 15.3804 17.5346 14.7246 17.5346 13.9156C17.5346 13.2639 17.0679 12.3557 16.1128 11.2265C15.1577 12.3557 14.6911 13.2639 14.6911 13.9156ZM10.8999 13.1832C9.85292 13.1832 9.00423 12.3088 9.00423 11.2302C9.00423 10.3783 9.52827 9.38837 10.5471 8.21857C10.7355 8.00234 11.0643 8.00234 11.2526 8.21857C12.2714 9.38837 12.7955 10.3783 12.7955 11.2302C12.7955 12.3088 11.9468 13.1832 10.8999 13.1832ZM9.95202 11.2302C9.95202 11.7695 10.3764 12.2067 10.8999 12.2067C11.4233 12.2067 11.8477 11.7695 11.8477 11.2302C11.8477 10.7579 11.5379 10.1042 10.8999 9.29531C10.2619 10.1042 9.95202 10.7579 9.95202 11.2302ZM21.3258 13.1832C20.2789 13.1832 19.4302 12.3088 19.4302 11.2302C19.4302 10.3783 19.9543 9.38837 20.9731 8.21857C21.1614 8.00234 21.4902 8.00234 21.6786 8.21857C22.6974 9.38837 23.2215 10.3783 23.2215 11.2302C23.2215 12.3088 22.3728 13.1832 21.3258 13.1832ZM20.378 11.2302C20.378 11.7695 20.8024 12.2067 21.3258 12.2067C21.8493 12.2067 22.2737 11.7695 22.2737 11.2302C22.2737 10.7579 21.9638 10.1042 21.3258 9.29531C20.6879 10.1042 20.378 10.7579 20.378 11.2302Z",
    fill: "#FF865D",
    stroke: "#FF865D",
    style: {
      fill: "#FF865D",
      fill: "color(display-p3 1.0000 0.5255 0.3647)",
      fillOpacity: 1,
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 0.402823
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCirclePeatlandRestoration);
export default __webpack_public_path__ + "static/media/project-type-circle-peatland-restoration.d6a2e686171c5724080c31d008b593c8.svg";
export { ForwardRef as ReactComponent };